// extracted by mini-css-extract-plugin
module.exports = {"plainText":"plainTextWrapper__plainText____1GRn","labelText":"plainTextWrapper__labelText___3rlY6"};